import { create } from 'zustand'

interface AlertState {
  isOpen: boolean
  title: string
  description: string
  variant: 'default' | 'success' | 'error' | 'warning'
  onConfirm?: () => void
  confirmText?: string
  showCancel?: boolean
}

interface AlertStore extends AlertState {
  showAlert: (config: Omit<AlertState, 'isOpen'>) => void
  hideAlert: () => void
}

export const useAlertStore = create<AlertStore>((set) => ({
  isOpen: false,
  title: '',
  description: '',
  variant: 'default',
  confirmText: 'OK',
  showCancel: false,
  showAlert: (config) => set({ ...config, isOpen: true }),
  hideAlert: () => set({ isOpen: false }),
}))

export function useAlert() {
  const { showAlert, hideAlert } = useAlertStore()

  const alert = {
    success: (title: string, description?: string) => {
      showAlert({
        title,
        description: description || '',
        variant: 'success',
        confirmText: 'OK',
        showCancel: false,
      })
    },
    error: (title: string, description?: string) => {
      showAlert({
        title,
        description: description || '',
        variant: 'error',
        confirmText: 'OK',
        showCancel: false,
      })
    },
    warning: (title: string, description?: string) => {
      showAlert({
        title,
        description: description || '',
        variant: 'warning',
        confirmText: 'OK',
        showCancel: false,
      })
    },
    info: (title: string, description?: string) => {
      showAlert({
        title,
        description: description || '',
        variant: 'default',
        confirmText: 'OK',
        showCancel: false,
      })
    },
    confirm: (title: string, description: string, onConfirm: () => void) => {
      showAlert({
        title,
        description,
        variant: 'default',
        confirmText: 'Confirmar',
        showCancel: true,
        onConfirm,
      })
    },
  }

  return { alert, hideAlert }
}
